import React, { useState, useEffect, useRef } from 'react'
import { FaRegFilePdf } from 'react-icons/fa'
import { MdDownload } from 'react-icons/md'
import cvEnglish from '../assets/Nacer_Mediouni_ProductEngineer_Resume_EN.pdf'
import cvFrench from '../assets/Nacer_Mediouni__CV.pdf'
import cvGerman from '../assets/Lebenslauf.docx.pdf'

const DownloadCVModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  // Reference for the modal
  const modalRef = useRef(null)

  // Toggle modal open/close
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  // Close modal when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsModalOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  // Handle download button click and close modal
  const handleDownloadClick = () => {
    setIsModalOpen(false)
  }

  return (
    <div>
      {/* Button to open the modal */}
      <button onClick={toggleModal} className="relative top-1">
        <FaRegFilePdf size={20} />
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div
          ref={modalRef}
          className="absolute right-[60%] top-[24%] md:right-[84%] md:top-[7%] lg:right-[84%] lg:top-[7%] p-4 border-2 border-[#00ffea] bg-black/10 backdrop-blur-sm rounded-3xl flex flex-row truncate w-max h-max"
        >
          {/* Modal content */}
          <div className="text-center">
            <h3 className="mb-4 text-sm font-semibold font-sans text-white">
              Download CV
            </h3>
            <div className="space-y-4">
              <a
                href={cvFrench}
                target="_blank"
                rel="noopener noreferrer"
                download="Nacer_Mediouni__CV.pdf"
                className="flex justify-center items-center p-2 gap-2 text-sm hover:bg-black bg-white text-black border-2 border-black hover:text-white rounded-md transition duration-200"
                onClick={handleDownloadClick} // Close modal on click
              >
                <MdDownload size={20} /> Fr
              </a>
              <a
                href={cvEnglish}
                target="_blank"
                rel="noopener noreferrer"
                download="Nacer_Mediouni_ProductEngineer_Resume_EN.pdf"
                className="flex justify-center items-center p-2 gap-2 text-sm hover:bg-black bg-white text-black border-2 border-black hover:text-white rounded-md transition duration-200"
                onClick={handleDownloadClick} // Close modal on click
              >
                <MdDownload size={20} />
                En
              </a>
              <a
                href={cvGerman}
                target="_blank"
                rel="noopener noreferrer"
                download="Lebenslauf.docx.pdf"
                className="flex justify-center items-center p-2 gap-2 text-sm hover:bg-black bg-white text-black border-2 border-black hover:text-white rounded-md transition duration-200"
                onClick={handleDownloadClick} // Close modal on click
              >
                <MdDownload size={20} />
                Gr
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default DownloadCVModal
